import React from 'react';
import { Container } from 'reactstrap';

const SecurityPolicy = () => {
  return (
    <Container className="py-5">
      <div className="legal-document">
        <h1 className="mb-4">Security Policy</h1>
        
        <section className="mb-4">
          <h2>1. Introduction</h2>
          <p>This Security Policy outlines our commitment to protecting the security and integrity of data within our SME and Supplier ESG Readiness Tool. We implement comprehensive security measures to safeguard personal information and ensure compliance with POPIA and other relevant security standards.</p>
        </section>

        <section className="mb-4">
          <h2>2. Security Framework</h2>
          <h3>2.1 Administrative Controls</h3>
          <ul>
            <li>Regular security training for employees</li>
            <li>Clear security policies and procedures</li>
            <li>Access control and authorization management</li>
            <li>Incident response procedures</li>
            <li>Regular security audits and assessments</li>
          </ul>

          <h3>2.2 Technical Controls</h3>
          <ul>
            <li>Encryption of data in transit and at rest</li>
            <li>Firewall protection</li>
            <li>Intrusion detection and prevention systems</li>
            <li>Regular security patches and updates</li>
            <li>Secure coding practices</li>
          </ul>

          <h3>2.3 Physical Controls</h3>
          <ul>
            <li>Secure data center facilities</li>
            <li>Access control systems</li>
            <li>Environmental controls</li>
            <li>Surveillance systems</li>
            <li>Disaster recovery procedures</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>3. Data Protection Measures</h2>
          <h3>3.1 Data Encryption</h3>
          <ul>
            <li>Transport Layer Security (TLS) for data in transit</li>
            <li>AES-256 encryption for data at rest</li>
            <li>Secure key management</li>
            <li>Regular encryption key rotation</li>
          </ul>

          <h3>3.2 Access Control</h3>
          <ul>
            <li>Multi-factor authentication</li>
            <li>Role-based access control</li>
            <li>Regular access reviews</li>
            <li>Password policies and management</li>
          </ul>

          <h3>3.3 Data Backup</h3>
          <ul>
            <li>Regular automated backups</li>
            <li>Encrypted backup storage</li>
            <li>Backup testing procedures</li>
            <li>Disaster recovery plans</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>4. Network Security</h2>
          <h3>4.1 Infrastructure Security</h3>
          <ul>
            <li>Firewall configuration</li>
            <li>Network segmentation</li>
            <li>DDoS protection</li>
            <li>Regular security monitoring</li>
          </ul>

          <h3>4.2 Application Security</h3>
          <ul>
            <li>Secure coding standards</li>
            <li>Regular security testing</li>
            <li>Input validation</li>
            <li>Output encoding</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>5. Incident Response</h2>
          <h3>5.1 Incident Detection</h3>
          <ul>
            <li>24/7 security monitoring</li>
            <li>Automated threat detection</li>
            <li>Security event logging</li>
            <li>Regular security assessments</li>
          </ul>

          <h3>5.2 Incident Response Procedures</h3>
          <ul>
            <li>Immediate incident notification</li>
            <li>Incident classification</li>
            <li>Containment procedures</li>
            <li>Recovery procedures</li>
            <li>Post-incident review</li>
          </ul>

          <h3>5.3 Data Breach Response</h3>
          <ul>
            <li>Immediate breach assessment</li>
            <li>Notification procedures</li>
            <li>Mitigation measures</li>
            <li>Regulatory reporting</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>6. Compliance and Auditing</h2>
          <h3>6.1 Readiness Assessments</h3>
          <ul>
            <li>Internal security audits</li>
            <li>External security assessments</li>
            <li>Vulnerability scanning</li>
            <li>Penetration testing</li>
          </ul>

          <h3>6.2 Compliance Monitoring</h3>
          <ul>
            <li>POPIA compliance checks</li>
            <li>Industry standard compliance</li>
            <li>Regular policy reviews</li>
            <li>Compliance reporting</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>7. Third-Party Security</h2>
          <h3>7.1 Vendor Management</h3>
          <ul>
            <li>Vendor security assessments</li>
            <li>Security requirements in contracts</li>
            <li>Regular vendor reviews</li>
            <li>Vendor monitoring</li>
          </ul>

          <h3>7.2 Cloud Security</h3>
          <ul>
            <li>Cloud provider security</li>
            <li>Data location controls</li>
            <li>Cloud access management</li>
            <li>Cloud security monitoring</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>8. Employee Security</h2>
          <h3>8.1 Security Training</h3>
          <ul>
            <li>Regular security awareness training</li>
            <li>Phishing awareness</li>
            <li>Password security</li>
            <li>Incident response training</li>
          </ul>

          <h3>8.2 Employee Responsibilities</h3>
          <ul>
            <li>Security policy compliance</li>
            <li>Incident reporting</li>
            <li>Data protection</li>
            <li>Access control</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>9. Updates to Security Policy</h2>
          <p>We regularly review and update this security policy to:</p>
          <ul>
            <li>Address new security threats</li>
            <li>Implement new security technologies</li>
            <li>Comply with updated regulations</li>
            <li>Improve security measures</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>10. Contact Information</h2>
          <p>For security-related inquiries or to report security incidents, please contact:</p>
          <ul>
            <li>Email: info@globalcompactsa.org.za</li>
            <li>Phone: +27 11 771 41 42</li>
            <li>Address: 26 Melville Road, Johannesburg, South Africa</li>
          </ul>
        </section>
      </div>
    </Container>
  );
};

export default SecurityPolicy; 